// extracted by mini-css-extract-plugin
export default {"submitBtn":"CancelUnconfirmedVisitsDialog_submitBtn__q9Vhl","confirmTitle":"CancelUnconfirmedVisitsDialog_confirmTitle__Rgr8h"};